import { render, staticRenderFns } from "./investment-tips.vue?vue&type=template&id=78c3b534&scoped=true"
import script from "./investment-tips.vue?vue&type=script&lang=js"
export * from "./investment-tips.vue?vue&type=script&lang=js"
import style0 from "./investment-tips.vue?vue&type=style&index=0&id=78c3b534&prod&scoped=true&lang=css"
import style1 from "./investment-tips.vue?vue&type=style&index=1&id=78c3b534&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c3b534",
  null
  
)

export default component.exports